module.exports = __webpack_public_path__ + "img/initiative_ac4.98e68224.jpg";